import React from 'react';
import BackButton from '../components/BackButton';
import { useTranslation } from 'react-i18next';
import { Mail, MessageCircle, MapPin } from 'lucide-react';
import Navbar from '../components/Navbar';

export default function Contacto() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <div className="container mx-auto px-4 md:px-6 max-w-3xl py-12">
        <BackButton />
        <h1 className="text-4xl font-heading font-bold text-[#134168] mb-2">{t('legal.contactTitle')}</h1>
        <p className="text-sm text-gray-400 mb-8">{t('legal.contactSubtitle')}</p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
          <a href="https://wa.me/18095550100" target="_blank" rel="noopener noreferrer" className="bg-white rounded-3xl p-6 shadow-sm hover:shadow-md transition-all flex items-start gap-4">
            <div className="w-12 h-12 bg-green-100 rounded-2xl flex items-center justify-center shrink-0">
              <MessageCircle className="w-6 h-6 text-green-600" />
            </div>
            <div>
              <p className="font-bold text-[#134168] mb-1">WhatsApp</p>
              <p className="text-gray-600 text-sm">+1 (809) 555-0100</p>
              <p className="text-xs text-gray-400 mt-1">{t('legal.contactWhatsappFast')}</p>
            </div>
          </a>
          <a href="mailto:info@redmobility.com" className="bg-white rounded-3xl p-6 shadow-sm hover:shadow-md transition-all flex items-start gap-4">
            <div className="w-12 h-12 bg-blue-100 rounded-2xl flex items-center justify-center shrink-0">
              <Mail className="w-6 h-6 text-blue-600" />
            </div>
            <div>
              <p className="font-bold text-[#134168] mb-1">Email</p>
              <p className="text-gray-600 text-sm">info@redmobility.com</p>
              <p className="text-xs text-gray-400 mt-1">{t('legal.contactEmailFast')}</p>
            </div>
          </a>
        </div>

        <div className="bg-white rounded-3xl p-8 shadow-sm">
          <div className="flex items-start gap-4 mb-4">
            <MapPin className="w-6 h-6 text-[#134168] shrink-0" />
            <div>
              <p className="font-bold text-[#134168]">{t('legal.contactOfficeTitle')}</p>
              <p className="text-gray-600 text-sm">{t('legal.contactOfficeAddress')}</p>
            </div>
          </div>
          <p className="text-xs text-gray-400">{t('legal.contactOperatedBy')}</p>
        </div>
      </div>
    </div>
  );
}
